import { IAction } from '~/src/store';

import { EPaymentActions } from './index';

export type TFillEmail = IAction<EPaymentActions.FILL_EMAIL, string>

const fillEmail = (email: string): TFillEmail => ({
    type: EPaymentActions.FILL_EMAIL,
    payload: email,
});

export default fillEmail;
